import { baseApi } from './baseApi';
import { normalizeKeys } from '../../utils/transform';

export interface ConversationResult {
  conversationId: string;
  status: 'processing' | 'completed' | 'failed';
  result?: {
    response: string;
    metadata?: Record<string, any>;
  };
  s3Reference?: string;
  createdAt: string;
}

function mapConversationPayload(raw: unknown): ConversationResult {
  const n = normalizeKeys<Record<string, unknown>>(raw);
  const status = n.status as ConversationResult['status'] | undefined;
  const topResponse = n.response;
  const meta = n.metadata as Record<string, unknown> | undefined;
  // lumina-api GET returns top-level `response`; UI/poll code expects `result.response`
  if (
    status === 'completed' &&
    topResponse != null &&
    topResponse !== '' &&
    n.result == null
  ) {
    return {
      ...n,
      result: {
        response:
          typeof topResponse === 'string'
            ? topResponse
            : JSON.stringify(topResponse),
        ...(meta ? { metadata: meta } : {}),
      },
    } as unknown as ConversationResult;
  }
  return n as unknown as ConversationResult;
}

export const conversationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getConversation: builder.query<ConversationResult, string>({
      query: (conversationId) => `/conversations/${conversationId}`,
      transformResponse: (raw: unknown) => mapConversationPayload(raw),
    }),
  }),
});

export const { useGetConversationQuery, useLazyGetConversationQuery } =
  conversationsApi;
